import { BindingError } from "../BindingError.js";
const throwNoopError = (callbackName) => {
  throw new BindingError(
    `Cannot invoke '${callbackName}' in non-sortable mode. The 'sortByField' parameter of the 'useSortedEntities' hook is undefined.`
  );
};
export {
  throwNoopError
};
//# sourceMappingURL=errors.js.map
